import PopupFormWrapper from "../popupFormWrapper";
import { GOALS } from "../../../../utils/tracking";

const FORM_CODE = "backCall";

export default function BackCall() {
  return (
    <PopupFormWrapper
      code={FORM_CODE}
      goalOpen={GOALS.backCallOpen}
      goalSent={GOALS.backCallSent}
      onSuccess={() => {
        if (
          window.location.href.includes(
            "vnesenie-izmeneniy-v-konstruktsiyu-ts-posle-ustanovki-farkopa_v_moskve",
          )
        ) {
          if (typeof ym !== "undefined") {
            // eslint-disable-next-line no-undef
            ym(20518312, "reachGoal", "mskRegFormSent");
          }
        } else if (
          window.location.href.includes(
            "vnesenie-izmeneniy-v-konstruktsiyu-ts-posle-ustanovki-farkopa_v_sankt-peterburge",
          )
        ) {
          if (typeof ym !== "undefined") {
            // eslint-disable-next-line no-undef
            ym(20518312, "reachGoal", "spbRegFormSent");
          }
        }
      }}
    />
  );
}
